"use client"

import Title from "@/components/common/Typography/Title"
import { useTour } from "@/hooks/tour/useTour"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Card, Col } from "antd"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons"

const TourDetailHighlights = () => {
  const { tour: { data: tour } } = useTour()
  const isDesktop = useIsDesktop()
  const { t } = useTranslation()

  const highlights = useMemo(() => {
    const raw = tour?.hightLights || (tour as { highlights?: string })?.highlights || ""
    return raw.split("|").map((s) => s.trim()).filter(Boolean)
  }, [tour])

  if (!highlights.length) return null

  return (
    <Col id="tour-section-highlights" span={24}>
      <Card
        className="tour-detail__section tour-detail__highlights-card"
        style={isDesktop ? {} : { borderRadius: 0 }}
        styles={{ body: { padding: "1.2rem 1.5rem" } }}
      >
        <Title level={4} className="tour-detail__section-title">
          {t("tour.highlights")}
        </Title>
        <ul className="tour-detail__highlights-list">
          {highlights.map((item) => (
            <li key={item} className="tour-detail__highlights-item">
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="tour-detail__highlights-icon"
                aria-hidden
              />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </Card>
    </Col>
  )
}

export default TourDetailHighlights
